import React from 'react';

export default React.createContext({
    version: '0.0.0'
});